(() => {
  'use strict';
  const copy = JSON.parse(document.getElementById('CTOFormUXCopy').textContent);
  const media = JSON.parse(document.getElementById('CTOFormMedia')?.textContent || '{}');
  const photo = (target,key) => {
    const item = JSON.parse(document.getElementById('CTOFormMedia')?.textContent || '{}')[key] || media[key]; if (!item) return false;
    const img = document.createElement('img'); img.src = item.src; img.alt = ''; img.width = 800; img.height = 450; img.loading = 'lazy'; img.decoding = 'async';
    if (item.small) { img.srcset = `${item.small} 480w, ${item.src} 800w`; img.sizes = '(max-width:749px) 45vw, 360px'; }
    target.replaceChildren(img); return true;
  };
  const icon = key => {
    const paths = {
      journey: '<path d="M7 28h34M12 28V17h24v11M16 17v-6h16v6M15 35h18M18 28v7m12-7v7"/>',
      place: '<path d="M36 20c0 10-12 21-12 21S12 30 12 20a12 12 0 0 1 24 0Z"/><circle cx="24" cy="20" r="4"/>',
      people: '<circle cx="18" cy="15" r="5"/><circle cx="32" cy="18" r="4"/><path d="M7 37v-5a11 11 0 0 1 22 0v5m0-11a9 9 0 0 1 12 8v3"/>',
      room: '<path d="M7 36V20m34 16V20M7 29h34M12 23v-8h24v8M7 35h34M17 15v8m14-8v8"/>',
      care: '<path d="m24 38-14-14a8 8 0 0 1 14-9 8 8 0 0 1 14 9Z"/>',
      document: '<path d="M13 7h16l7 7v27H13Zm16 0v9h7M19 24h11M19 31h11"/>',
      time: '<circle cx="24" cy="24" r="16"/><path d="M24 13v12l8 5"/>',
      chat: '<path d="M8 10h32v23H22L11 41v-8H8Z"/><path d="M16 19h16m-16 7h10"/>',
    };
    return `<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="24" cy="24" r="23" fill="#edf3e7" stroke="none"/>${paths[key] || paths.chat}</svg>`;
  };
  const iconFor = (value, select) => {
    if (select.matches('[data-trip-room]')) return 'room';
    if (select.matches('[data-trip-payment]')) return 'document';
    if (select.matches('[data-trip-origin], [data-voyage-destination], [data-visa-passport]')) return 'place';
    value = value.toLowerCase();
    return /hajj|badal|sadaqa|aqiqa|mobilite/.test(value) ? 'care' : /hotel/.test(value) ? 'room' : /guide|visite/.test(value) ? 'place' : /omra|transfert/.test(value) ? 'journey' : 'chat';
  };
  const choices = (select, onPick, { long = false, values } = {}) => {
    if (!select || select.ctoCards) return select?.ctoCards;
    const cards = document.createElement('div'); cards.className = `cto-ux-cards${long ? ' cto-ux-cards--long' : ''}${onPick ? '' : ' cto-ux-cards--stay'}`;
    cards.setAttribute('role', 'group');
    const label = select.labels?.[0];
    if (label) { if (!label.id) label.id = `${select.id}-label`; cards.setAttribute('aria-labelledby', label.id); }
    const buttons = new Map();
    [...select.options].filter(option => option.value && (!values || values.includes(option.value))).forEach(option => {
      const button = document.createElement('button'); button.type = 'button'; button.className = 'cto-ux-card';
      const picture = document.createElement('span'); picture.className = 'cto-ux-picture';
      if (photo(picture,option.value)) { button.append(picture); button.classList.add('cto-ux-card--photo'); cards.classList.add('cto-ux-gallery'); }
      else { button.innerHTML = icon(iconFor(option.value, select)); button.classList.add('cto-ux-card--plain'); }
      const text = document.createElement('span'); text.className = 'cto-ux-card-label'; text.textContent = option.textContent; button.append(text);
      button.addEventListener('click', () => { select.value = option.value; select.dispatchEvent(new Event('change', { bubbles: true })); onPick?.(option.value); });
      buttons.set(option, button); cards.append(button);
    });
    const sync = () => buttons.forEach((button, option) => {
      button.hidden = option.hidden; button.disabled = select.disabled || option.disabled;
      button.setAttribute('aria-pressed', String(select.value === option.value));
      button.querySelector('.cto-ux-card-label').textContent = option.textContent;
    });
    select.insertAdjacentElement('afterend', cards);
    if (!values) { select.hidden = true; label?.classList.add('visually-hidden'); }
    select.addEventListener('change', sync);
    new MutationObserver(sync).observe(select, { subtree: true, attributes: true, attributeFilter: ['hidden', 'disabled'], childList: true, characterData: true });
    select.ctoCards = { cards, sync }; sync(); return select.ctoCards;
  };
  const controls = step => [...step.querySelectorAll('input,select,textarea')].filter(field => !field.disabled);
  const validate = step => {
    const invalid = controls(step).find(field => !field.checkValidity());
    if (!invalid) return true;
    if (invalid.ctoCards) invalid.hidden = false;
    const details = invalid.closest('details'); if (details) details.open = true;
    invalid.focus(); invalid.reportValidity(); return false;
  };
  const journey = (root, options = {}) => {
    if (root.ctoJourney) return root.ctoJourney;
    const steps = [...root.querySelectorAll('[data-ux-step]')];
    if (steps.length < 2) return;
    root.classList.add('cto-ux');
    const nav = document.createElement('div'); nav.className = 'cto-ux-nav';
    const back = document.createElement('button'); back.type = 'button'; back.textContent = `← ${copy.back}`;
    const status = document.createElement('span'); status.setAttribute('role', 'status');
    const progress = document.createElement('progress'); progress.max = steps.length; progress.setAttribute('aria-label', copy.progress);
    nav.append(back, status, progress); root.prepend(nav);
    const recap = document.createElement('div'); recap.className = 'cto-ux-recap';
    const lastTitle = steps.at(-1).querySelector('legend,[data-ux-title]');
    if (lastTitle) lastTitle.after(recap); else steps.at(-1).prepend(recap);
    let current = 0;
    const show = (index, focus = true) => {
      current = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach((step, i) => { step.hidden = i !== current; });
      back.hidden = current === 0;
      status.textContent = `${current + 1} / ${steps.length}`; progress.value = current + 1;
      if (current === steps.length - 1) {
        recap.replaceChildren();
        steps.slice(0,-1).forEach((step,index) => step.querySelectorAll('select,input[type=radio]:checked').forEach(field => {
          if (!field.value || field.disabled) return;
          const label = field.tagName === 'SELECT' ? field.selectedOptions[0]?.textContent : field.value;
          if (!label) return;
          const edit = document.createElement('button'); edit.type = 'button'; edit.textContent = `${label} ✎`;
          edit.setAttribute('aria-label', `${copy.back} : ${label}`); edit.addEventListener('click', () => show(index)); recap.append(edit);
        }));
      }
      const title = steps[current].querySelector('[data-ux-title],legend,label');
      if (focus && title) {
        title.tabIndex = -1; title.focus({ preventScroll: true });
        const modalBody = root.closest('.cto-popup__body');
        if (modalBody) modalBody.scrollTo(0, 0);
        else nav.scrollIntoView({ block: 'start' });
      }
      options.onShow?.(current);
    };
    const advance = () => { if (validate(steps[current])) show(current + 1); };
    back.addEventListener('click', () => show(current - 1));
    root.querySelectorAll('[data-ux-next]').forEach(button => button.addEventListener('click', advance));
    root.querySelectorAll('select[data-ux-cards]').forEach(select => choices(select, select.hasAttribute('data-ux-auto') ? () => { if (select.value !== select.dataset.uxStopValue) advance(); } : null, { long: select.hasAttribute('data-ux-long') }));
    root.querySelectorAll('select[data-ux-country-cards]').forEach(select => choices(select, advance, { values: ['France', 'Belgium', 'Switzerland'] }));
    root.querySelectorAll('select[data-ux-auto]:not([data-ux-cards])').forEach(select => select.addEventListener('change', () => { if (select.value) advance(); }));
    root.addEventListener('invalid', event => {
      const index = steps.findIndex(step => step.contains(event.target));
      if (index >= 0 && index !== current) show(index, false);
      if (event.target.ctoCards) event.target.hidden = false;
      const details = event.target.closest('details'); if (details) details.open = true;
    }, true);
    // A card advances a question; only the final explicit submit sends data or starts checkout.
    const form = root.matches('form') ? root : root.closest('form') || root.querySelector('form');
    form?.addEventListener('submit', event => {
      if (current < steps.length - 1) { event.preventDefault(); event.stopImmediatePropagation(); advance(); return; }
      for (let i = 0; i < steps.length; i++) {
        if (controls(steps[i]).some(field => !field.checkValidity())) { event.preventDefault(); event.stopImmediatePropagation(); show(i, false); validate(steps[i]); return; }
      }
    }, true);
    root.ctoJourney = { show, advance, get current() { return current; } };
    show(root.querySelector('[data-cto-inquiry-error], [aria-invalid=true]') ? steps.length - 1 : 0, false);
    return root.ctoJourney;
  };
  const feedback = (form, state, message) => {
    let panel = form.querySelector('[data-cto-form-feedback]');
    if (!panel) { panel = document.createElement('div'); panel.className = 'cto-form-feedback'; panel.dataset.ctoFormFeedback = ''; panel.tabIndex = -1; const submit = form.querySelector('button[type=submit]'); if (submit) submit.insertAdjacentElement('afterend',panel); else form.append(panel); }
    panel.dataset.state = state; panel.setAttribute('role', state === 'error' ? 'alert' : 'status'); panel.textContent = message; panel.hidden = false;
    return panel;
  };
  const busy = (form, message = copy.sending) => {
    form.setAttribute('aria-busy', 'true'); feedback(form, 'pending', message);
  };
  const release = form => { form.removeAttribute('aria-busy'); const panel = form.querySelector('[data-cto-form-feedback]'); if (panel?.dataset.state === 'pending') panel.hidden = true; };
  window.CTOFormUX = { choices, journey, feedback, busy, release, copy, photo };
  const bind = (scope = document) => {
    scope.querySelectorAll('[data-ux-journey]').forEach(root => journey(root));
    scope.querySelectorAll('select[data-ux-cards]').forEach(select => choices(select));
    scope.querySelectorAll('[data-cto-inquiry-success],.cto-hajj-request__success').forEach(result => {
      result.classList.add('cto-form-feedback'); result.dataset.state = 'success';
      if (!result.querySelector('p')) { const original = document.createElement('div'); while (result.firstChild) original.append(result.firstChild); const help = document.createElement('p'); help.textContent = copy.after_request; original.append(help); result.append(original); }
      const dialog = result.closest('dialog');
      if (dialog && !result.querySelector('[data-ux-dismiss]')) {
        const close = document.createElement('button'); close.type = 'button'; close.className = 'button button--secondary'; close.textContent = copy.close; close.dataset.uxDismiss = '';
        close.addEventListener('click', () => dialog.close()); (result.querySelector('div') || result).append(close);
      }
    });
    scope.querySelectorAll('.newsletter-form-message--success').forEach(result => {
      result.classList.add('cto-form-feedback'); result.dataset.state = 'success';
    });
    scope.querySelectorAll('form[action*="/contact"]').forEach(form => {
      if (!['contact','customer'].includes(form.querySelector('[name=form_type]')?.value) || form.dataset.uxFeedbackReady) return;
      form.dataset.uxFeedbackReady = 'true'; form.classList.add('cto-ux');
      form.addEventListener('submit', event => {
        if (form.dataset.uxSubmitting === 'true') { event.preventDefault(); return; }
        queueMicrotask(() => {
          if (form.dataset.humanMode === 'whatsapp') return;
          const checking = event.defaultPrevented;
          if (!checking) {
            form.dataset.uxSubmitting = 'true';
            form.querySelectorAll('button[type=submit]').forEach(button => button.setAttribute('aria-disabled','true'));
          }
          const message = checking ? window.CTOHumanForms?.copy.verifying || copy.sending : copy.sending;
          busy(form,message);
          const panel = form.querySelector('[data-cto-form-feedback]'); panel?.focus({preventScroll:true}); panel?.scrollIntoView?.({block:'center'});
          try { sessionStorage.setItem('cto-form-return', JSON.stringify({path:location.pathname,time:Date.now(),formId:form.id,method:form.dataset.humanMode || ''})); } catch (_) {}
          window.setTimeout(() => {
            if (!form.isConnected || form.getAttribute('aria-busy') !== 'true') return;
            feedback(form,'pending',copy.slow);
          },12000);
        });
      });
    });
  };
  const focusResult = () => {
    const returnedId = window.CTOFormReturn?.formId || location.hash.slice(1);
    const returnedForm = returnedId ? document.getElementById(returnedId) : null;
    const result = returnedForm?.querySelector('[data-cto-inquiry-success], [data-cto-inquiry-error], [data-cto-form-feedback]');
    // Preserve a visitor's own focus choice if they have already started interacting.
    const active = document.activeElement;
    if (result && (!active || active === document.body || active === returnedForm || active === result.closest('dialog')) && !result.closest('[hidden]') && result.getClientRects().length) result.focus({preventScroll:true});
  };
  const recoverReturn = () => {
    const marker = window.CTOFormReturn;
    const form = marker?.formId && document.getElementById(marker.formId);
    if (!form || form.querySelector('[data-cto-inquiry-success], [data-cto-inquiry-error]')) return;
    // A navigation without a server result is uncertain; never infer success from a client marker.
    const root = form.querySelector('[data-ux-journey]'); root?.ctoJourney?.show(Number.MAX_SAFE_INTEGER, false);
    const panel = feedback(form, 'error', window.CTOHumanForms.copy.unconfirmed);
    panel.focus({preventScroll:true}); panel.scrollIntoView?.({block:'center'});
  };
  document.addEventListener('DOMContentLoaded', () => { bind(); requestAnimationFrame(recoverReturn); document.documentElement.classList.remove('cto-form-returning');
    if (window.CTOFormReturn) { try { sessionStorage.removeItem('cto-form-return'); } catch (_) {} }
    requestAnimationFrame(focusResult); });
  document.addEventListener('shopify:section:load', event => bind(event.target));
  window.addEventListener('load', () => requestAnimationFrame(focusResult));
  window.addEventListener('pageshow', () => {
    requestAnimationFrame(focusResult);
    document.documentElement.classList.remove('cto-form-returning');
    document.querySelectorAll('form[aria-busy=true]').forEach(release);
    document.querySelectorAll('form[data-ux-submitting=true]').forEach(form => {
      delete form.dataset.uxSubmitting;
      form.querySelectorAll('button[type=submit]').forEach(button => button.removeAttribute('aria-disabled'));
    });
  });
})();
